/*
 * Canadian Black Friday (cbf-*) page script: landing + booked pages.
 *
 * Config comes from window.cbfConfig and window.cbfState, both written by
 * sections/cbf-base.liquid before this file runs.
 *
 * The "cbf" in content_name is cfg.prefix (CBF - Base "Tracking prefix"), so
 * other showroom events (e.g. sgs = The Scary Good Sale) reuse this file.
 *
 * Tracking: the Facebook & Instagram app runs its pixel in Shopify's OPEN
 * context, so window.fbq exists on the page shortly after load (it also sends
 * PageView; this file never does). Events go straight to fbq with an eventID
 * once it exists (waits up to 10 s). Do NOT add a custom pixel in Customer
 * events for these pages, or every event double-counts.
 *
 *   landing  ViewContent  { content_name: cbf_<slug> }            once per session
 *            CalendarView (custom)            booking section in view, once per session
 *            CTAClick     { cta, model? }     (custom)             1 s double-tap guard
 *                         cta: hero | card | footer | sticky | fallback
 *   booked   Schedule     { content_name: <Schedule name, default cbf_test_ride_<slug>>,
 *                            content_category: <prefix>, ctb_trigger: 'referrer' }
 *            only when document.referrer is cfg.ycbmHost (blank: any *.youcanbook.me), once per session,
 *            never on reload / back-forward, never inside an iframe
 */
(function () {
  "use strict";
  if (window.cbfLandingInitialised) return;
  window.cbfLandingInitialised = true;

  var cfg = window.cbfConfig || {};
  var DEBUG = !!cfg.debug;

  var inFrame = false;
  try { inFrame = window.top !== window.self; } catch (e) { inFrame = true; }

  function log() {
    if (!DEBUG || !window.console) return;
    console.log.apply(console, ["[CBF]"].concat(Array.prototype.slice.call(arguments)));
  }

  /* ---------- storage (every access guarded) ---------- */

  function ssGet(key) {
    try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function ssSet(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (e) { /* private mode */ }
  }

  var fired = {};
  /* True the first time per tab session, false after (survives refresh). */
  function once(key) {
    var k = "cbf_once_" + (cfg.contentName || cfg.slug || "") + "_" + key;
    if (fired[k] || ssGet(k) === "1") return false;
    fired[k] = true;
    ssSet(k, "1");
    return true;
  }

  var lastTap = {};
  function debounced(key, ms) {
    var now = Date.now();
    if (lastTap[key] && now - lastTap[key] < ms) return false;
    lastTap[key] = now;
    return true;
  }

  function eventId(prefix) {
    return prefix + "_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 10);
  }

  /* ---------- Meta via window.fbq ---------- */

  var metaQueue = [];
  var metaPolling = false;

  function metaFlush() {
    if (typeof window.fbq !== "function") return false;
    while (metaQueue.length) {
      var item = metaQueue.shift();
      try {
        window.fbq(item[0], item[1], item[2], { eventID: item[3] });
        log("fbq", item[0], item[1], item[2], item[3]);
      } catch (e) {
        log("fbq failed", item[1], e);
      }
    }
    return true;
  }

  function metaPoll(tries) {
    if (metaFlush() || tries > 40) { metaPolling = false; return; }
    setTimeout(function () { metaPoll(tries + 1); }, 250);
  }

  /* kind: "track" | "trackCustom" */
  function track(kind, name, params) {
    if (inFrame) return;
    metaQueue.push([kind, name, params || {}, eventId("cbf_" + name.toLowerCase())]);
    if (!metaFlush() && !metaPolling) { metaPolling = true; metaPoll(0); }
  }

  /* ---------- UTM + fbclid capture (landing URL → sessionStorage) ---------- */

  var UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

  function attribution() {
    var stored = {};
    try { stored = JSON.parse(ssGet("cbf_attr") || "{}") || {}; } catch (e) { stored = {}; } /* shared on purpose: UTMs are per visit */
    try {
      var params = new URLSearchParams(window.location.search);
      var fresh = {};
      var found = false;
      UTM_KEYS.concat(["fbclid"]).forEach(function (k) {
        var v = params.get(k);
        if (v) { fresh[k] = v.slice(0, 250); found = true; }
      });
      if (found) {
        stored = fresh;
        ssSet("cbf_attr", JSON.stringify(stored));
      }
    } catch (e) { /* old browser */ }
    return stored;
  }

  var attr = attribution();

  /* ---------- event state + countdown ---------- */

  var root = document.documentElement;

  function pad(n) { return (n < 10 ? "0" : "") + n; }

  function tick() {
    if (typeof window.cbfState !== "function") return;
    var s = window.cbfState(new Date());
    if (root.getAttribute("data-cbf-state") !== s.state) {
      root.setAttribute("data-cbf-state", s.state);
      log("state", s.state);
    }
    if (!s.target) return;
    var diff = Math.max(0, s.target - new Date());
    var units = {
      days: String(Math.floor(diff / 86400000)),
      hours: pad(Math.floor((diff % 86400000) / 3600000)),
      minutes: pad(Math.floor((diff % 3600000) / 60000)),
      seconds: pad(Math.floor((diff % 60000) / 1000))
    };
    var boxes = document.querySelectorAll("[data-cbf-countdown]");
    for (var i = 0; i < boxes.length; i++) {
      for (var k in units) {
        var el = boxes[i].querySelector('[data-unit="' + k + '"]');
        if (el && el.textContent !== units[k]) el.textContent = units[k];
      }
    }
  }

  /* ---------- CTA clicks (delegated) ---------- */

  document.addEventListener("click", function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest("[data-cbf-cta]") : null;
    if (!a) return;
    var cta = a.getAttribute("data-cbf-cta");
    var model = a.getAttribute("data-cbf-model") || "";
    if (!debounced("cta_" + cta + model, 1000)) return;
    var params = { cta: cta, content_name: cfg.contentName };
    if (model) params.model = model;
    track("trackCustom", "CTAClick", params);
    /* Fallback link leaves the page in this tab: give the event a moment to send. */
    if (a.hasAttribute("data-cbf-fallback") && typeof window.fbq === "function" && !ev.metaKey && !ev.ctrlKey) {
      ev.preventDefault();
      var href = a.href;
      setTimeout(function () { window.top.location.href = href; }, 300);
    }
  }, true);

  /* ---------- calendar view (landing only) ---------- */

  function initCalendarView() {
    var zone = document.querySelector("[data-cbf-book-zone]");
    if (!zone || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      if (once("calendar_view")) track("trackCustom", "CalendarView", { content_name: cfg.contentName });
    }, { rootMargin: "0px 0px -35% 0px" }); /* top of the booking section is in the upper 65% of the screen */
    io.observe(zone);
  }

  /* ---------- sticky bar: hide while the booking section is on screen ---------- */

  function initSticky() {
    var bar = document.querySelector("[data-cbf-sticky]");
    if (!bar) return;
    document.body.classList.add("cbf-has-sticky");
    var zone = document.querySelector("[data-cbf-book-zone]");
    if (!zone || !("IntersectionObserver" in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle("is-hidden", entries[0].isIntersecting);
    }, { rootMargin: "-45% 0px -45% 0px" }).observe(zone); /* booking covers the middle of the screen */
  }

  /* ---------- booking embed: UTMs, model prefill, warm-up, height ---------- */

  function initBooking() {
    var frame = document.querySelector("[data-cbf-ycbm]");
    if (!frame) return;
    var zone = document.querySelector("[data-cbf-book-zone]");
    var note = document.querySelector("[data-cbf-model-note]");
    var noteName = note ? note.querySelector("[data-cbf-model-name]") : null;
    var base = frame.getAttribute("data-cbf-src");
    var param = frame.getAttribute("data-cbf-param");
    var upper = frame.getAttribute("data-cbf-utm-upper") === "true";
    var modelKey = "cbf_model_" + (cfg.contentName || "");
    var model = ssGet(modelKey) || "";

    var fallback = document.querySelector("[data-cbf-fallback]");
    var fallbackBase = fallback ? fallback.getAttribute("href") : "";

    function extras() {
      var parts = [];
      UTM_KEYS.forEach(function (k) {
        if (attr[k]) parts.push(encodeURIComponent(upper ? k.toUpperCase() : k) + "=" + encodeURIComponent(attr[k]));
      });
      if (model && param) parts.push(encodeURIComponent(param) + "=" + encodeURIComponent(model));
      return parts.join("&");
    }
    function src() {
      var x = extras();
      return base + (x ? "&" + x : "");
    }
    /* Fallback link: same UTMs (and model) on the plain YCBM page. */
    function updateFallback() {
      if (!fallback || !fallbackBase) return;
      var x = extras();
      fallback.href = fallbackBase + (x ? (fallbackBase.indexOf("?") === -1 ? "?" : "&") + x : "");
    }
    updateFallback();

    function showModel() {
      if (!model || !note || !noteName) return;
      noteName.textContent = model;
      note.hidden = false;
    }

    /* Warm-up: no src for the first paint, then load once the page is idle
       (or on first scroll/tap) so it is ready by the time anyone gets there.
       YCBM only downloads its app once its root is on screen, so while warming
       the iframe peeks a transparent 20px strip in at the bottom of the
       viewport (.cbf-ycbm-peek), then settles back into the booking box when
       the box comes into view, YCBM reports its height, or after 10 s. */
    var box = frame.parentNode;
    var loaded = false;
    var peeking = false;
    function settle() {
      if (!peeking) return;
      peeking = false;
      frame.classList.remove("cbf-ycbm-peek");
      box.style.minHeight = "";
      log("ycbm settled");
    }
    function load() {
      if (loaded) return;
      loaded = true;
      var r = box.getBoundingClientRect();
      var inView = r.top < window.innerHeight && r.bottom > 0;
      if (!inView && "IntersectionObserver" in window) {
        box.style.minHeight = frame.offsetHeight + "px";
        frame.classList.add("cbf-ycbm-peek");
        peeking = true;
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { settle(); io.disconnect(); }
        });
        io.observe(box);
        setTimeout(settle, 10000);
      }
      frame.src = src();
      log("ycbm load", frame.src, peeking ? "(peek)" : "");
    }
    function loadSoon() {
      if (window.requestIdleCallback) window.requestIdleCallback(load, { timeout: 2500 });
      else setTimeout(load, 1200);
    }
    if (document.readyState === "complete") loadSoon();
    else window.addEventListener("load", loadSoon);
    ["scroll", "touchstart", "pointerdown"].forEach(function (type) {
      window.addEventListener(type, load, { passive: true, once: true });
    });
    showModel();

    /* Door crasher card: remember the model, prefill it, scroll to booking. */
    document.addEventListener("click", function (ev) {
      var card = ev.target && ev.target.closest ? ev.target.closest("[data-cbf-model]") : null;
      if (!card) return;
      var picked = card.getAttribute("data-cbf-model");
      if (!picked) return;
      ev.preventDefault();
      var changed = picked !== model;
      model = picked;
      ssSet(modelKey, model);
      showModel();
      updateFallback();
      if (!loaded) load();
      else if (changed && param) frame.src = src();
      (zone || box).scrollIntoView({ behavior: "smooth", block: "start" });
      try { window.history.replaceState(null, "", window.location.pathname + window.location.search + "#" + (zone ? zone.id : "")); } catch (e) {}
    });

    /* YCBM posts its content height as a bare number. */
    window.addEventListener("message", function (ev) {
      var host = "";
      try { host = new URL(ev.origin).hostname; } catch (e) { return; }
      if (!/(^|\.)youcanbook\.me$/.test(host)) return;
      var h = parseInt(ev.data, 10);
      if (h > 200 && h < 10000) {
        frame.style.height = h + "px";
        setTimeout(settle, 300);
      }
    });
  }

  /* ---------- booked page ---------- */

  /* The city's own YCBM host when set (CBF - Base "YouCanBook.me host"), else any *.youcanbook.me. */
  function cameFromYcbm() {
    try {
      if (!document.referrer) return false;
      var host = new URL(document.referrer).hostname.toLowerCase();
      if (cfg.ycbmHost) return host === String(cfg.ycbmHost).toLowerCase();
      return /(^|\.)youcanbook\.me$/.test(host);
    } catch (e) { return false; }
  }

  /* A reload or back/forward keeps the YCBM referrer; it is not a new booking. */
  function isRevisit() {
    try {
      var nav = performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
      if (nav) return nav.type === "reload" || nav.type === "back_forward";
      if (performance.navigation) return performance.navigation.type === 1 || performance.navigation.type === 2;
    } catch (e) { /* old browser */ }
    return false;
  }

  /* Add to calendar: hrefs are built here from the ISO settings so the times
     are right whatever the shop's or the visitor's timezone. */
  function utcStamp(d) {
    return d.getUTCFullYear() + pad(d.getUTCMonth() + 1) + pad(d.getUTCDate()) + "T" +
      pad(d.getUTCHours()) + pad(d.getUTCMinutes()) + pad(d.getUTCSeconds()) + "Z";
  }
  function icsEscape(s) {
    return String(s || "").replace(/\\/g, "\\\\").replace(/,/g, "\\,").replace(/;/g, "\\;").replace(/\n/g, "\\n");
  }
  function initCalendar() {
    var wrap = document.querySelector("[data-cbf-cal]");
    if (!wrap) return;
    var start = new Date(wrap.getAttribute("data-start"));
    var end = new Date(wrap.getAttribute("data-end"));
    if (isNaN(start) || isNaN(end)) return;
    var title = wrap.getAttribute("data-title") || "";
    var loc = wrap.getAttribute("data-location") || "";
    var details = wrap.getAttribute("data-details") || "";
    var dates = utcStamp(start) + "/" + utcStamp(end);
    var g = wrap.querySelector('[data-cbf-cal-link="google"]');
    if (g) {
      g.href = "https://calendar.google.com/calendar/render?action=TEMPLATE&text=" + encodeURIComponent(title) +
        "&dates=" + dates + "&location=" + encodeURIComponent(loc) + "&details=" + encodeURIComponent(details);
    }
    var i = wrap.querySelector('[data-cbf-cal-link="ics"]');
    if (i) {
      var ics = [
        "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Biktrix//Showroom Sale//EN", "BEGIN:VEVENT",
        "UID:" + (cfg.prefix || "cbf") + "-" + (cfg.slug || "showroom") + "-" + utcStamp(start) + "@biktrix.ca",
        "DTSTAMP:" + utcStamp(new Date()), "DTSTART:" + utcStamp(start), "DTEND:" + utcStamp(end),
        "SUMMARY:" + icsEscape(title), "LOCATION:" + icsEscape(loc), "DESCRIPTION:" + icsEscape(details),
        "END:VEVENT", "END:VCALENDAR"
      ].join("\r\n");
      i.href = "data:text/calendar;charset=utf-8," + encodeURIComponent(ics);
    }
    wrap.hidden = false;
  }

  /* ---------- boot ---------- */

  function start() {
    tick();
    setInterval(tick, 1000);

    if (cfg.role === "booked") {
      initCalendar();
      if (inFrame) return;
      if (!cameFromYcbm()) {
        log("booked page opened without a referrer from " + (cfg.ycbmHost || "*.youcanbook.me") + ": no Schedule");
      } else if (isRevisit()) {
        log("reload/back-forward: no Schedule");
      } else if (once("schedule")) {
        track("track", "Schedule", { content_name: cfg.scheduleContentName, content_category: cfg.prefix || "cbf", ctb_trigger: "referrer" });
      }
      return;
    }

    initSticky();
    initBooking();
    if (inFrame) return;
    if (once("view")) track("track", "ViewContent", { content_name: cfg.contentName });
    initCalendarView();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
